import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, InfoTooltip } from '@ui';
import { FormInput } from 'components/Form/next';
import { useContext, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FilterContext from '../Filter/FilterContext';

interface Props {
    filterName?: string;
    filterTooltip?: string;
    filterKey: string;
    callback?: () => void;
    size?: 'xs' | 'md';
    // Volle Spaltenbreite statt fixer 400px (Formular-Kontext)
    fullWidth?: boolean;
    datetime?: boolean;
}

export const DateRangeFilter = ({ filterKey, filterName, filterTooltip, size = 'xs', fullWidth = false, callback, datetime = false }: Props) => {
    const { t } = useTranslation('datatable');
    const [filter, setFilter] = useContext(FilterContext);
    const methods = useForm({ defaultValues: filter?.[filterKey] });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        reset(filter?.[filterKey]);
    }, [filter, filterKey, reset]);

    const handleSubmitFilter = (data) => {
        setFilter({
            ...filter,
            [filterKey]: data
        });
        callback?.();
    };

    const resetFilter = () => {
        setFilter({ ...filter, [filterKey]: undefined });
        callback?.();
    };

    return (
        <form onSubmit={handleSubmit(handleSubmitFilter)}>
            <div
                className="tw-flex tw-w-full tw-items-baseline tw-gap-6 tw-px-2"
                style={{ minWidth: fullWidth || size !== 'xs' ? '100%' : 400 }}
            >
                {filterName && (
                    <b className="tw-flex tw-min-w-[30%] tw-items-center tw-gap-1 tw-truncate tw-whitespace-nowrap tw-text-sm">
                        {filterName}
                        {filterTooltip && <InfoTooltip tooltip={filterTooltip} />}
                    </b>
                )}
                <FormProvider {...methods}>
                    <div className="tw-min-w-0 tw-flex-1">
                        <FormInput.DatePicker
                            containerClassName="!tw-mt-0"
                            width="100%"
                            labelLeft={t('filters.rangeFrom')}
                            color="success"
                            size={size}
                            bordered
                            placement="bottom"
                            granularity={datetime ? 'minute' : 'day'}
                            name="from"
                        />
                    </div>
                    <div className="tw-min-w-0 tw-flex-1">
                        <FormInput.DatePicker
                            containerClassName="!tw-mt-0"
                            width="100%"
                            labelLeft={t('filters.rangeTo')}
                            color="success"
                            size={size}
                            bordered
                            placement="bottom"
                            granularity={datetime ? 'minute' : 'day'}
                            name="to"
                        />
                    </div>
                </FormProvider>
                <div className="tw-flex tw-shrink-0 tw-gap-2">
                    <Button type="button" color="error" auto size={size} onPress={resetFilter}>
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                    <Button type="submit" color={filter?.[filterKey] ? 'warning' : 'success'} auto size={size}>
                        <FontAwesomeIcon icon={faCheck} />
                    </Button>
                </div>
            </div>
        </form>
    );
};
